import {UserObjectApi} from '../../../utils/types';

// Action types
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
export const SET_CURRENT_USER = 'auth/SET_CURRENT_USER';


/**
 * logoutSuccess Action Creator
 *
 * Creates an action to indicate that the user has successfully logged out.
 *
 * @returns {object} An action object with the type `LOGOUT_SUCCESS`.
 */
export const logoutSuccess = () => ({type: LOGOUT_SUCCESS});

/**
 * loginSuccess Action Creator
 *
 * Creates an action to indicate that the user has successfully logged in.
 *
 * @param {boolean} isAuthenticated - Indicates if the user is authenticated.
 * @param {UserObjectApi|null} user - The user object returned from the API or `null` if unavailable.
 *
 * @returns {object} An action object with:
 *  - `type`: `LOGIN_SUCCESS`
 *  - `isAuthenticated`: Authentication status.
 *  - `payload`: The user object containing user details.
 */
export const loginSuccess = (isAuthenticated: boolean, user: UserObjectApi | null) => {
    return ({
        type: LOGIN_SUCCESS,
        isAuthenticated: isAuthenticated,
        payload: user,
    });
};

export const setCurrentUser = (user: UserObjectApi) => ({
    type: SET_CURRENT_USER,
    payload: user,
});